<template>
  <div v-if="isLayerShow && observatories.length > 0">
    <div v-for="ob in observatories" :key="ob.osid">
      <l-marker :lat-lng="[ob.lat, ob.lng]">
        <l-icon
          :icon-size="[36, 12]"
          :icon-anchor="[18, 6]"
          :class-name="'snow-marker'"
        >
          <div class="snow-contents">
            <div :style="{ color: getSnowColor(ob.status) }">
              {{ ob.status === null ? "-" : ob.status }}
              <span class="unit">cm</span>
            </div>
          </div>
        </l-icon>
      </l-marker>
    </div>
  </div>
</template>
<script>
import { LIcon, LMarker } from "vue2-leaflet";
import { OBSERVATORY } from "@/enums/Type";
export default {
  name: "ObservatorySnowLayer",
  components: {
    LIcon,
    LMarker
  },
  computed: {
    observatories() {
      const observatories = this.$store.getters.observatories;
      return observatories.filter(obs => {
        return obs.type === OBSERVATORY.SNOW.code;
      });
    },
    riskSubControl() {
      return this.$store.getters.riskSubControl;
    },
    isLayerShow() {
      return this.riskSubControl.observatory.includes(OBSERVATORY.SNOW.code);
    }
  },
  methods: {
    getSnowColor(speed) {
      const value = speed;
      const colors = [
        { color: "#ba206e", value: "200" },
        { color: "#ff3700", value: "150" },
        { color: "#ffa021", value: "100" },
        { color: "#fbf43c", value: "50" },
        { color: "#0041FF", value: "20" },
        { color: "#218CFF", value: "5" },
        { color: "#A0D2FF", value: "1" },
        { color: "#FFFFFF", value: "0" }
      ];

      let current;
      for (const color of colors) {
        if (color.value <= value) {
          current = color.color;
          break;
        }
      }
      return current;
    }
  }
};
</script>
<style lang="scss">
.leaflet-pane.leaflet-marker-pane {
  z-index: 700;
}
.snow-marker {
  z-index: 800 !important;
}
.v-icon.outlined {
  color: white;
  text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000,
    1px 1px 0 #000;
}
.snow-contents {
  color: white;
  font-size: 16px;
  font-weight: bold;
  white-space: nowrap;
  text-align: center;
  text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000,
    1px 1px 0 #000;
  .unit {
    font-size: 12px;
    margin-left: 3px;
    font-weight: normal;
  }
}
</style>
